export type TobaccoNonUseType = 'FORMER' | 'NEVER';

export interface TobaccoUse {
  usesTobacco: boolean | null;
  nonUseType: TobaccoNonUseType | null;
  quitDate: string | null;
  statusChangedAt?: string | null;
}

export type TobaccoUseInput = Omit<TobaccoUse, 'statusChangedAt'>;

export const unknownTobaccoUse = (): TobaccoUseInput => ({
  usesTobacco: null,
  nonUseType: null,
  quitDate: null,
});

export function buildTobaccoUseInput(
  usesTobacco: boolean | null,
  nonUseType: TobaccoNonUseType | null,
  quitDate: string | null,
): TobaccoUseInput {
  if (usesTobacco === true) {
    return {usesTobacco: true, nonUseType: null, quitDate: null};
  }
  if (usesTobacco === false) {
    return {
      usesTobacco: false,
      nonUseType,
      quitDate: nonUseType === 'FORMER' ? quitDate : null,
    };
  }
  return unknownTobaccoUse();
}
